export default function getPerspectives() {
    return fetch(`/rest/perspective`, {
        credentials: 'same-origin',
    }).then((response) => {
        if (response.ok) {
            return response.json();
        } else {
            var error = new Error(response.statusText);
            error.response = response;
            throw error;
        }
    });
}
